import axios from "axios"
import API_URLS from "../../config/global_variables";
import { triggerNotification } from "../common/notify"; // adjust path if needed
import globalData from "../../config/global_data";
import common_api from "../../config/common_api";
import common_mapping from "../../config/common_mapping";
const userData = localStorage.userData?JSON.parse(localStorage.userData):"";
// triggerNotification({
//   type: 'success',
//   title: 'Success!',
//   message: 'Data fetched successfully.',
// });

// triggerNotification({
//   type: 'error',
//   title: 'Error!',
//   message: 'Something went wrong.',
// });
const initialData = Array.from({ length: 50 }, (_, index) => {
  const key = (index + 1).toString();
  return {
    key,
    sapSku: `SAP90${index.toString().padStart(2, '0')}`,
    sapName: "text",
    sapCustomerNumber: index % 2 === 0 ? "US" : "UK",
    sapPrice: "$45",
    sapMsrp: "$45",
    availableStock: 150,
    reservedStock: 150,
    bcSku: `BC123${index}`,
    type: "Simple",
    active: true,
    store: "GER",
    bcInventory: 27,
    subscription: "Yes",
    enrichment: index % 5 !== 0, // every 5th is false
    lastUpdated: "22-10-2024, 14:33:11",
    action: index % 10 === 2 ? "create" : "Edit",
  };
});

const apidata = async () => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_SAP_PRODUCT,
      headers: {
        'Content-Type': 'application/json', 'Authorization': userData.token
      },
    };

    let data = await axios.request(config)    
    if (data.status === 200) {
      const mappedData = await common_mapping.map_saplist(data.data.result)
      return mappedData      
    }else{

      return false
    }
    return []

  } catch (error) {
    triggerNotification({
      type: 'error',
      title: 'Error!',
      message: 'Something went wrong. Please contact admin.',
    })
    return false
  }
}


const active_inactive_status = async (reqdata = {}, status) => {
  try {
    if (reqdata && (reqdata.prdouct_data || (reqdata.variant_data && reqdata.variant_data.id))) {
      let objdata = {}
      if (reqdata.prdouct_data) {
        objdata = {
          "store": reqdata.store,
          "product_id": reqdata.prdouct_data.product_id,
          "status": status,
          "is_variant": false
        }
      } else if (reqdata.variant_data) {
        objdata = {
          "store": reqdata.store,
          "product_id": reqdata.prod_id,
          "status": status,
          "is_variant": true,
          "variant_id": reqdata.variant_data.variant_id
        }
      } else {
        return false
      }
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URLS.UPDATE_BC_PRODUCT_STATUS,
        headers: {
          'Content-Type': 'application/json', 'Authorization': userData.token
        },
        data: JSON.stringify(objdata)
      };

      const data = await axios.request(config)
      if (data.status === 200 && !data.data.error) {
        let responsedata = await data.data.refreshed_data;
        let finaldataafterupdte = await common_api.mapped_all(responsedata)
        return {
          type: 'success',
          title: 'Success!',
          message: data.data.message,
          data: finaldataafterupdte
        };
      }
      if (data.status === 200 && data.data.error) {
        return {
          type: 'error',
          title: 'Error!',
          message: data.data.error,
        };
      }
      return false;
    } else {
      return {
        type: 'error',
        title: 'Error!',
        message: "data not found",
      }
    }

  } catch (error) {
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
  }
}

let apiService = { initialData, apidata, active_inactive_status };

export default apiService;
